import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Build from './components/Build';
import Founders from './components/Founders';
import Mission from './components/Mission';
import Training from './components/Training';
import Careers from './components/Careers';
import Footer from './components/Footer';
import EnquireNowButton from './components/EnquireNowButton';
import TrainingsPage from './components/TrainingsPage';

function Home() {
  const [showEnquire, setShowEnquire] = useState(true);
  const heroRef = useRef(null);
  const trainingRef = useRef(null);

  useEffect(() => {
    function onScroll() {
      if (!heroRef.current || !trainingRef.current) return;
      const heroRect = heroRef.current.getBoundingClientRect();
      const trainingRect = trainingRef.current.getBoundingClientRect();
      const heroInView = heroRect.top < 100 && heroRect.bottom > 200;
      const trainingInView = trainingRect.top < 100 && trainingRect.bottom > 200;
      setShowEnquire(!(heroInView || trainingInView));
    }
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="min-h-screen w-full" style={{ backgroundColor: 'var(--bg)' }}>
      <Navbar />
      <div ref={heroRef}>
        <Hero />
      </div>
      <About />
      <Build />
      <Founders />
      <Mission />
      <div ref={trainingRef} id="training-section">
        <Training setHideEnquire={setShowEnquire} />
      </div>
      <Careers />
      <Footer />
      {showEnquire && <EnquireNowButton />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/trainings" element={<TrainingsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
